import Vue from 'vue'
import Vuex from 'vuex'
import radar from './modules/radar.store'
import data from './modules/data.store'
import refine from './modules/refine.store'
import algolia from './modules/algolia.store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    radar,
    data,
    refine,
    algolia,
  },
  strict: process.env.NODE_ENV !== 'production',
})
